module.exports = __webpack_public_path__ + "img/clic.50b0109a.gif";